import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { MessageSquare, Sparkles } from "lucide-react";

const CONNIE_PIC = "https://static.prod-images.emergentagent.com/jobs/a56d87f3-5a30-4665-8a60-444757bad179/images/f5247092efeca540e36b7ecec0b5764dbf994a3b6fdf8535a7c5e6b0b1d7650b.jpeg";

const COPY = {
  business: {
    title: "Hey, welcome aboard! Please read this 👋",
    body: [
      "I'm Connie, your guide here at Salesman Connect. We just launched, so here's the deal:",
      "Your founder account comes with free startup Core Credits to post jobs, and those posts don't expire until you get 10 applications. Zero pressure.",
      "Keep your profile up and post a role or two now while we bring more top salespeople onto the platform, early companies get seen first!",
    ],
  },
  salesman: {
    title: "Hey, welcome aboard! Please read this 👋",
    body: [
      "I'm Connie, your guide here at Salesman Connect. We just launched, and here's the good news:",
      "Building and keeping your profile live and updated is 100% free, always.",
      "Go ahead and complete your profile now while we bring more great companies onto the platform to hire from, complete profiles get discovered first!",
    ],
  },
};

export const WelcomeModal = () => {
  const [role, setRole] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    let r = null;
    try { r = localStorage.getItem("sc_welcome"); } catch {}
    if (r === "business" || r === "salesman") setRole(r);
  }, []);

  const close = () => {
    try { localStorage.removeItem("sc_welcome"); } catch {}
    setRole(null);
  };

  if (!role) return null;
  const c = COPY[role];

  return (
    <Dialog open onOpenChange={(o) => !o && close()}>
      <DialogContent data-testid="welcome-modal" className="max-w-md border-white/10 bg-slate-900/95 backdrop-blur-xl">
        <div className="flex flex-col items-center text-center">
          <div className="relative">
            <img src={CONNIE_PIC} alt="Connie" className="w-20 h-20 rounded-full object-cover ring-2 ring-emerald-500/40" />
            <span className="absolute -bottom-1 -right-1 w-7 h-7 rounded-full bg-emerald-500 flex items-center justify-center border-2 border-slate-900"><Sparkles className="w-3.5 h-3.5 text-slate-900" /></span>
          </div>
          <DialogTitle className="text-xl font-black tracking-tight text-white mt-4">{c.title}</DialogTitle>
          <DialogDescription className="sr-only">A welcome note from Connie to help you get started on Salesman Connect.</DialogDescription>
          <div className="mt-3 space-y-3 text-sm text-slate-300 leading-relaxed">
            {c.body.map((p, i) => <p key={i}>{p}</p>)}
          </div>
          <p className="text-xs text-slate-500 mt-4">I've also dropped this note in your inbox, reply anytime, I read every message. 💬</p>
          <div className="flex flex-col sm:flex-row gap-2 mt-6 w-full">
            <Button data-testid="welcome-read-message" onClick={() => { close(); nav("/messages"); }}
              className="flex-1 rounded-full bg-emerald-500 hover:bg-emerald-400 text-slate-900 font-bold gap-2">
              <MessageSquare className="w-4 h-4" /> Read Connie's message
            </Button>
            <Button data-testid="welcome-dismiss" variant="outline" onClick={close}
              className="flex-1 rounded-full border-white/20 bg-white/5 text-white hover:bg-white/10 hover:text-white font-bold">
              Got it, let's go
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomeModal;
